import { Button } from "@/components/ui";

interface SubmitCancelButtonsProps {
  isSaving: boolean;
  onCancel?: () => void;
  onSave?: () => void;
  buttonSize?: "xs" | "sm";
  savingDisabled?: boolean;
}

export const SubmitCancelButtons = ({
  isSaving,
  onCancel,
  onSave,
  buttonSize = "xs",
  savingDisabled = false,
}: SubmitCancelButtonsProps) => {
  return (
    <div className="flex justify-end gap-2">
      {onCancel && (
        <Button
          disabled={isSaving}
          variant="secondary"
          size={buttonSize}
          type="button"
          data-testid="cancel-button"
          onClick={onCancel}
        >
          Cancel
        </Button>
      )}
      <Button
        disabled={isSaving || savingDisabled}
        variant="primary"
        size={buttonSize}
        type="submit"
        data-testid="submit-button"
        isLoading={isSaving}
        onClick={onSave}
      >
        Save
      </Button>
    </div>
  );
};
